export const QA_NAME_USER_NAME = 'user'

export const QA_NAME_USER_LOGGED = 'loggedUser'
